
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'BlogListPost',
  props: ['post'],
  computed: {
    ...mapGetters({
      getCategoryNameById: 'wp/getCategoryNameById',
      getCategorySlugById: 'wp/getCategorySlugById',
      getPostAuthor: 'wp/getPostAuthor',
      getPostAuthorSlug: 'wp/getPostAuthorSlug',
    }),
    postAuthor() {
      return this.getPostAuthor(this.post)
    },
    postAuthorSlug() {
      return this.getPostAuthorSlug(this.post)
    },
  },
})
